export const pad = (num, size = 2) => {
  return String(num).padStart(size, '0')
}
